import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=d15aca62&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15aca62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d15aca62')) {
      api.createRecord('d15aca62', component.options)
    } else {
      api.reload('d15aca62', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=d15aca62&scoped=true&", function () {
      api.rerender('d15aca62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29boiMhVHujKi/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports